import React, { useState } from "react";
import Email from "../../../Components/Inputs/Email";
import Password from "../../../Components/Inputs/Password";
import LoginHeader from "../../Login/Components/LoginHeader";
import LoginCarousel from "../../Login/LoginCarousel";

import OtpModal from "../../Login/Components/OtpModal";
import SignupForm from "./Component/SignupForm";

import { toast } from "react-toastify";
import http from "../../../utils/http";
import "./Signup.scss";

export default function Signup() {
  const [showOtpModal, setShowOtpModal] = useState<boolean>(false);
  const [phone, setPhone] = useState();
  const [password, setPassword] = useState();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const handleSubmit = async (e, data) => {
    const { phone, password } = data;
    setPhone(phone);
    setPassword(password);
    try {
      const response = await http.POST("auth/register", { phone, password });
      console.log("response", response);
      if (response?.data?.error) {
        toast(response?.data?.message);
      } else {
        setShowOtpModal(true);
      }
    } catch (err) {
      console.log("error while register");
    }
  };
  const handleOtpModalClose = () => {
    setShowOtpModal(false);
  };
  return (
    <div className="signup_container">
      <LoginHeader />
      <div className="signup_body">
        <div className="signup_carousel">
          <LoginCarousel />
        </div>
        <div className="signup_info_container">
          <SignupForm handleSubmit={handleSubmit} />
        </div>
      </div>

      {/* modals here */}
      <OtpModal data={{ phone, password }} showModal={showOtpModal} handleClose={handleOtpModalClose} />
    </div>
  );
}
